module.exports = __webpack_public_path__ + "static/media/information-icon.8e291ca5.svg";